module.exports = __webpack_public_path__ + "static/media/gladiator.f763323d.jpg";